<template>
  <a
    :href="whatsappLink"
    target="_blank"
    class="fixed bottom-36 right-4 z-50 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:scale-110 active:scale-95 transition-transform duration-200"
  >
    <div class="w-8 h-8">
      <ColorImg
        src="/images/icons/whatsapp.svg"
        fallback="/images/icons/chat.svg"
        class="w-full h-full bg-white"
        alt="WhatsApp"
      />
    </div>
  </a>
</template>

<script setup>
import { getStore } from '@core/store';
import { computed } from 'vue';

const appDataStore = getStore('appData');
const userStore = getStore('user');

const whatsappLink = computed(() => {
  const country = userStore.state.current?.countryCode || 'ALL';
  const contacts = appDataStore.state.data?.contacts;
  const general = appDataStore.state.data?.general;

  // Prioritize country-specific contact, then 'ALL'
  const contact = (contacts && contacts[country]) || (contacts && contacts['ALL']);
  const phoneNumber = contact?.whatsappPhoneNumber || general?.whatsappAssistanceLink?.split('/').pop();

  if (phoneNumber && /^\d+$/.test(phoneNumber)) {
    return `https://wa.me/${phoneNumber}?text=Bonjour 1BPay, j'ai besoin d'aide.`;
  }

  // Final fallback to the raw link string if no valid number found
  return contact?.whatsappChatLink || general?.whatsappAssistanceLink || 'https://wa.me/';
});
</script>
